import React from "react";
import { LeadsActionHandlerProps } from "./action-types";
import MassDelete from "./mass-delete";
import MassUpdate from "./mass-update/mass-update";
import ExportLeads from "./export-leads";
import AddToCampaignModal from "./add-new-campaign/add-new-campiagn";
import MassConvert from "./mass-convert";

const LeadActionHandler: React.FC<LeadsActionHandlerProps> = (
    {
        selectedLeadsMap,
        setSelectedLeadsMap,
        selectedActions,
        setSelectedActions,
        menuItems,
        setMenuItems,
        fetchLeads,
        selectedLeadActionScope,
        setselectedLeadActionScope,
        totalRecords,
        handleMassActionMenuClose,
        leadsData,
    }
) => {
    const fetchIsOpen = (action: string) => {
        return menuItems.find((item) => item.value === action)?.isOpen || false;
    }

    return (
        <div className="lead-action-handler">
            <MassDelete
                leadsIds={Object.values(selectedLeadsMap).flat() || []}
                isOpen={fetchIsOpen("Archive")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                fetchLeads={fetchLeads}
                setSelectedLeadsMap={setSelectedLeadsMap}
                selectedLeadActionScope={selectedLeadActionScope}
                setselectedLeadActionScope={setselectedLeadActionScope}
                totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
            />
            <MassUpdate
                leadsIds={Object.values(selectedLeadsMap).flat() || []}
                isOpen={fetchIsOpen("Update")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                fetchLeads={fetchLeads}
                selectedLeadActionScope={selectedLeadActionScope}
                setselectedLeadActionScope={setselectedLeadActionScope}
                totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
                setSelectedLeadsMap={setSelectedLeadsMap}
                leadsData={leadsData}
            />
             <MassConvert
                leadsIds={Object.values(selectedLeadsMap).flat() || []}
                isOpen={fetchIsOpen("Convert")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                fetchLeads={fetchLeads}
                selectedLeadActionScope={selectedLeadActionScope}
                setselectedLeadActionScope={setselectedLeadActionScope}
                totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
                setSelectedLeadsMap={setSelectedLeadsMap}
                leadsData={leadsData}
            />
            <ExportLeads
                leadsIds={Object.values(selectedLeadsMap).flat() || []}
                isOpen={fetchIsOpen("Export Leads")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                fetchLeads={fetchLeads}
                handleMassActionMenuClose={handleMassActionMenuClose}
                setSelectedLeadsMap={setSelectedLeadsMap}
            />
            <AddToCampaignModal
                leadsIds={Object.values(selectedLeadsMap).flat() || []}
                isOpen={fetchIsOpen("Add to Campaigns")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                // setSelectedActions={setSelectedActions}
                // fetchLeads={fetchLeads}
                // selectedLeadActionScope={selectedLeadActionScope}
                // setselectedLeadActionScope={setselectedLeadActionScope}
                // totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
            // setSelectedLeadsMap={setSelectedLeadsMap}
            />
        </div>
    )
}

export default LeadActionHandler;